
class BlockBuilderUserCache {
  constructor(prefix = 'block-builder') {
    this.prefix = prefix;
    this.cache = {};
    this.loadFromStorage();
  }

  get(key, defaultValue = null) {
    const fullKey = `${this.prefix}_${key}`;
    const item = this.cache[fullKey];
    
    if (!item) {
      return defaultValue;
    }

    // Check if item has expired
    if (item.ttl > 0 && (Date.now() - item.timestamp) > item.ttl) {
      this.delete(key);
      return defaultValue;
    }

    return item.value;
  }

  set(key, value, ttl = 0) {
    const fullKey = `${this.prefix}_${key}`;
    this.cache[fullKey] = {
      value,
      ttl,
      timestamp: Date.now(),
    };
    this.saveToStorage();
  }

  clear() {
    this.cache = {};
    this.clearStorage();
  }

  delete(key) {
    const fullKey = `${this.prefix}_${key}`;
    delete this.cache[fullKey];
    this.saveToStorage();
  }

  loadFromStorage() {
    try {
      const stored = localStorage.getItem(`${this.prefix}_userState`);
      if (stored) {
        this.cache = JSON.parse(stored);
        // Clean up expired items
        this.cleanupExpired();
      }
    } catch (error) {
      console.warn('Failed to load cache from localStorage:', error);
      this.cache = {};
    }
  }

  saveToStorage() {
    try {
      localStorage.setItem(`${this.prefix}_userState`, JSON.stringify(this.cache));
    } catch (error) {
      console.warn('Failed to save cache to localStorage:', error);
    }
  }

  clearStorage() {
    try {
      localStorage.removeItem(`${this.prefix}_userState`);
    } catch (error) {
      console.warn('Failed to clear cache from localStorage:', error);
    }
  }

  cleanupExpired() {
    const now = Date.now();
    const keysToDelete = [];

    Object.keys(this.cache).forEach(key => {
      const item = this.cache[key];
      if (item.ttl > 0 && (now - item.timestamp) > item.ttl) {
        keysToDelete.push(key);
      }
    });

    keysToDelete.forEach(key => {
      delete this.cache[key];
    });

    if (keysToDelete.length > 0) {
      this.saveToStorage();
    }
  }
}